import _ from 'lodash';
import React, { Component } from 'react';

import { StarRating } from '../shared';

import { getFourboxTalentCategories } from '../../util';

class EditTalentCard extends Component {

  state = {
    talents: [],
    ratings: {},
  }

  ratingForTalentId(talentId){
    return this.state.ratings[talentId] || 0;
  }
  currentRatingForTalentId(talentId){
    const { jointReview, managerReview } = this.props;

    const currentReview = jointReview ? jointReview : managerReview;

    if(currentReview){
      return currentReview.ratings[talentId];
    }
    else{
      return 0;
    }
  }

  getInitialRatingsForTalents(talents){
    let initialRatings = {};

     _.each(talents, talent => {
      initialRatings[talent.id] = this.currentRatingForTalentId(talent.id);
    });

    return initialRatings;
  }

  componentWillMount(){
    console.log('complete talent eval mounted!');

    const talents = this.props.talents;

    //console.log('setting prior reviews to: ', this.props.priorReviews);

    this.setState({
      talents,
      ratings: this.getInitialRatingsForTalents(talents)
    });
  }

  formIsComplete(){
    let allTalentsHaveRatings = true;

    const { talents, ratings } = this.state;

    _.each(talents, talent => {
      if(ratings[talent.id] === undefined){
        allTalentsHaveRatings = false;
      }
    });

    return allTalentsHaveRatings;
  }

  updateRatings(){
    if(!this.formIsComplete()){
      return;
    }

    this.props.updateRatings(this.state.ratings);
  }

  renderActions(){

    const formIsComplete = this.formIsComplete();

    return(
      <div className="actions">
        <button onClick={this.updateRatings.bind(this)} className="button primary" disabled={!formIsComplete || this.props.updatingRatings}>Update ratings</button>
        <button onClick={this.props.cancel} className="button grey-outline button-sm cancel">Cancel and discard changes</button>
      </div>
    )
  }

  talentsForCategory(category){
    //use this state talents
    return _.filter(this.state.talents, talent => {

      if(talent.category !== category){
        return false;
      }
      else{
        return true;
      }
    });
  }

  updateTalentRating(talent, newRating){
    this.setState({
      ratings: {
        ...this.state.ratings,
        [talent.id]: newRating
      }
    }, () => {
      console.log('updating rating state: ', this.state);
    });
  }

  renderTalentRatings(talent){
    if(this.props.priorReviews){

      console.log('this.props.priorReviews: ', this.props.priorReviews);

      return(
        <div className="talent-ratings multiple">
          <div className="talent-rating">
            <StarRating
              ratingLabel="Current talent rating"
              maxRating={10}
              currentRating={this.ratingForTalentId(talent.id)}
              updateRating={rating => { this.updateTalentRating(talent, rating); }}
              ratingExplanations={talent.ratings}
              includeRatingExplanationPlaceholder={true}
            />
          </div>
        </div>
      )
    }
    else{
      return (
        <div className="talent-ratings">
          <div className="talent-rating">
            <StarRating
              ratingLabel=""
              maxRating={10}
              currentRating={this.ratingForTalentId(talent.id)}
              updateRating={rating => { this.updateTalentRating(talent, rating); }}
              ratingExplanations={talent.ratings}
              includeRatingExplanationPlaceholder={true}
            />
          </div>
        </div>
      )
    }
  }

  renderTalent(talent){
    return(
      <div key={talent.id} className="talent">
        <div className="talent-info">
          <div className="talent-name">{talent.name}</div>
          <div className="talent-definition">{talent.definition || `Example definition for ${talent.name}`}</div>
        </div>
        {this.renderTalentRatings(talent)}
      </div>
    )
  }

  render(){
    return(
      <div className="talent-evaluation-review">
        <div className="organization-talents">
          {_.map(getFourboxTalentCategories(), talentCategory => {
            return (
              <div key={talentCategory.key} className="talent-category">
                <div className="talents-section-header">{talentCategory.name}</div>
                {_.map(this.talentsForCategory(talentCategory.key), this.renderTalent.bind(this))}
              </div>
            );
          })}

          {this.renderActions()}
        </div>
      </div>
    );
  }
}

export default EditTalentCard;



// WEBPACK FOOTER //
// ./src/components/talents/editTalentEvaluation.js